import * as React from 'react';

export function ProblemSection() {
  return (
    <section className="gastro-problem">
      <style>{`
        .gastro-problem {
          padding: 72px 24px;
          background: #fff;
        }
        .gastro-problem-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .gastro-problem h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .gastro-problem .accent {
          font-size: 22px;
          font-weight: 600;
          color: #c53030;
          margin: 0 0 28px;
        }
        .gastro-problem p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .gastro-problem .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .gastro-fail-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .gastro-fail-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #555;
          padding: 10px 14px;
          background: #fef2f2;
          border-radius: 8px;
        }
        .gastro-fail-list li i {
          color: #c53030;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .gastro-problem h2 {
            font-size: 24px;
          }
          .gastro-fail-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="gastro-problem-inner">
        <h2>El ingrediente más caro no es el tomate.</h2>
        <p className="accent">Es la mala experiencia del cliente.</p>
        <p>
          La materia prima vegetal representa una <span className="highlight">parte pequeña del costo</span> de un plato.
          Pero representa el <span className="highlight">100% del sabor y la frescura</span>.
        </p>
        <p>
          Ahorrar en calidad puede salir mucho más caro que pagar unos pesos más por un producto consistente.
        </p>
        <p className="highlight">Un proveedor que falla genera:</p>
        <ul className="gastro-fail-list">
          <li><i className="fa fa-times-circle" /> Desperdicio</li>
          <li><i className="fa fa-times-circle" /> Ajustes de último momento</li>
          <li><i className="fa fa-times-circle" /> Platos que no salen igual</li>
          <li><i className="fa fa-times-circle" /> Clientes que no vuelven</li>
        </ul>
      </div>
    </section>
  );
}
